export function excludedCatalogIds(existingMap, toRemoveSet, toAddMap) {
    return new Set([
        ...[...existingMap.keys()].filter(id => !toRemoveSet.has(id)),
        ...toAddMap.keys(),
    ]);
}